import { render } from "./PksView.vue?vue&type=template&id=935c64aa"
import script from "./PksView.vue?vue&type=script&lang=js"
export * from "./PksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__